module.exports = __webpack_public_path__ + "img/yj.238c326b.png";